// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__mOolZ","actions":"GroupTable_actions__2v2LS","deleteModalFooter":"GroupTable_deleteModalFooter__3EBFU"};